<template>
    <div :class="['move-model', {'move-model--compressed': display_compressed}]">
        <div class="move-model__title">{{ model.label }}</div>
        <div class="move-model__body">
            <move-item v-for="(item) in model.items" :key="item.id" :item="item" :options="options">
            </move-item>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        "model": {
            required: true,
        },
        "options": {
            required: true,
        },
    },
    data() {
        return {
        };
    },
    computed: {
        status() {
            if (this.model.items.every(item => {
                return item.status == 'success';
            })) {
                return 'success';
            }
            if (this.model.items.some(item => {
                return item.status == 'danger';
            })) {
                return 'danger';
            }
            return 'warning';
        },
        display_compressed() {
            return this.options.display_level == 'compressed';
        }
    },
    watch: {
        status() {
            this.model.status = this.status;
        }
    },

    methods: {
    },

    mounted() {
        this.model.status = this.status;
    },
}
</script>
